// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectSession,
    selectCurrentGame,
    selectCurrentBanner,
} from '../../../features/session/sessionSlice';

// Components
import Loading from '../../templates/StateScreen/Loading';
import SessionScreen from '../../organisms/SessionScreen/SessionScreen';
import SessionIdle from '../../molecules/SessionIdle/SessionIdle';
import Banner from '../../molecules/Banner/Banner';
import Countdown from '../../atoms/Countdown/Countdown';
import Lead from '../../atoms/Lead/Lead';

// Hooks
import useCountdownTimer from '../../../hooks/useCountdownTimer';

// Utilities
import getCurrentPotTotal from '../../../utils/misc/getCurrentPotTotal';

/**
 * @function GameStarting
 * Countdown to next game with advertisement
 *
 * @example
 * return (
 *   <GameStarting />
 * )
 */
function GameStarting(): JSX.Element {
    const session = useAppSelector(selectSession);
    const currentBanner = useAppSelector(selectCurrentBanner);
    const game = useAppSelector(selectCurrentGame);
    const gameMeta = session?.games.find(({ id }) => id === game.id);
    const startTime = new Date(`${game.start}`);
    const timeDiff = useCountdownTimer(startTime);
    const totalPoints =
        game.currentPot.length > 0 ? getCurrentPotTotal(game.currentPot) : 0;

    if (session === null || session === undefined || timeDiff <= 0) {
        return <Loading text="Loading session..." />;
    }

    return (
        <SessionScreen>
            <SessionIdle>
                <Lead>
                    {session?.games.length > 1 ? (
                        <>
                            Get ready for <b>Game {gameMeta?.sort_order}</b>{' '}
                            where we are playing for{' '}
                            <b>{totalPoints} Port Points</b>
                        </>
                    ) : (
                        <>
                            Get ready, we are playing for{' '}
                            <b>{totalPoints} Port Points</b>
                        </>
                    )}
                </Lead>
                {!Number.isNaN(timeDiff) && <Countdown time={timeDiff} />}
                {session.banners.length > 0 && (
                    <Banner
                        name={session.banners[currentBanner].name}
                        link={session.banners[currentBanner].link}
                        image={`https://cdn.zentrl.io/target-adverts/banners/${session.banners[currentBanner].image}`}
                        text={session.banners[currentBanner].text}
                    />
                )}
            </SessionIdle>
        </SessionScreen>
    );
}

// Exports
export default GameStarting;
